module.exports = __webpack_public_path__ + "images/banner-logo.png";